import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { MatChipsModule } from '@angular/material/chips'
import { RouterModule } from '@angular/router'
import { CartSharedModule } from '@spartacus/cart/base/components'
import { AuthGuard, CmsConfig, FeaturesConfigModule, I18nModule, provideConfig, UrlModule } from '@spartacus/core'
import { CardModule, CmsPageGuard, PageLayoutComponent, PromotionsModule, SpinnerModule } from '@spartacus/storefront'
import { CustomCartSharedModule } from '../../cart/cart-shared/custom-cart-shared.module'
import { MaterialModule } from '../../shared/material.module'
import { SharedModule } from '../../shared/shared.module'
import { OrderStatusModule } from '../order-status/order-status.module'
import { CustomOrderDetailTotalsComponent } from './custom-order-detail-totals/custom-order-detail-totals.component'
import { OrderDetailsHeadlineComponent } from './custom-order-details-items/custom-order-details-headline/order-details-headline.component'
import { CustomOrderDetailsItemsComponent } from './custom-order-details-items/custom-order-details-items.component'
import { CustomOrderOverviewComponent } from './custom-order-overview/custom-order-overview.component'

@NgModule({
  declarations: [
    CustomOrderDetailsItemsComponent,
    OrderDetailsHeadlineComponent,
    CustomOrderOverviewComponent,
    CustomOrderDetailTotalsComponent
  ],

  imports: [
    CartSharedModule,
    CardModule,
    CommonModule,
    I18nModule,
    FeaturesConfigModule,
    PromotionsModule,
    UrlModule,
    SpinnerModule,
    MatChipsModule,
    RouterModule.forChild([
      {
        path: null,
        canActivate: [AuthGuard, CmsPageGuard],
        component: PageLayoutComponent,
        data: { pageLabel: 'order', cxRoute: 'orderGuest' }
      },
      {
        path: null,
        canActivate: [AuthGuard, CmsPageGuard],
        component: PageLayoutComponent,
        data: { cxRoute: 'orderDetails' }
      }
    ]),
    MaterialModule,
    CustomCartSharedModule,
    SharedModule,
    OrderStatusModule
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        AccountOrderDetailsItemsComponent: {
          component: CustomOrderDetailsItemsComponent
        },
        AccountOrderDetailsOverviewComponent: {
          component: CustomOrderOverviewComponent
        },
        AccountOrderDetailsTotalsComponent: {
          component: CustomOrderDetailTotalsComponent
        }
      }
    })
  ],
  exports: [
    CustomOrderDetailsItemsComponent,
    OrderDetailsHeadlineComponent,
    CustomOrderOverviewComponent,
    CustomOrderDetailTotalsComponent
  ]
})
export class CustomOrderDetailsModule {}
